export const navbar = [
  { route: "/about", msgKey: "about" },
  { route: "/#categories", msgKey: "categories" },
  { route: "/offers", msgKey: "offers" },
  { route: "/blog", msgKey: "blog" },
  { route: "/faq", msgKey: "faq" },
  { route: "/#contact", msgKey: "contact" },
];
export const categories = [
  { category: "Vêtement", imgUrl: "/images/vetement.png", id: "1" },
  { category: "Meuble", imgUrl: "/images/meuble.png", id: "2" },
  { category: "Shoes", imgUrl: "/images/shoes.png", id: "3" },
  { category: "Vêtement1", imgUrl: "/images/vetement.png", id: "4" },
  { category: "Meuble1", imgUrl: "/images/meuble.png", id: "5" },
  { category: "Shoes1", imgUrl: "/images/shoes.png", id: "6" },
  { category: "Vêtement2", imgUrl: "/images/vetement.png", id: "7" },
  { category: "Meuble2", imgUrl: "/images/meuble.png", id: "8" },
  { category: "Shoes2", imgUrl: "/images/shoes.png", id: "9" },
  { category: "Vêtement3", imgUrl: "/images/vetement.png", id: "10" },
  { category: "Meuble3", imgUrl: "/images/meuble.png", id: "11" },
  { category: "Shoes3", imgUrl: "/images/shoes.png", id: "12" },
];
